export default "__VITE_ASSET__DLSf5PuF__"